module.exports = __webpack_public_path__ + "img/agradecimiento_2019.700c5f6a.png";